import { NBSP } from 'shared/constants/symbols';

import type { IOffer } from 'shared/offer';

export function getFloorRange(offer: IOffer): string | undefined {
  if (offer.floorNumber) {
    let floorInfo = `${offer.floorNumber}`;

    if (offer.building && offer.building.floorsCount) {
      floorInfo += `/${offer.building.floorsCount}`;
    }

    floorInfo += `${NBSP}эт.`;

    return floorInfo;
  }

  return undefined;
}
